import { Text } from 'react-native'
import { styled } from '~/utils'

export const Label = styled(Text, theme => {
  return {
    base: {
      fontSize: theme.fontSizeThreepulse,
      color: 'red',
    },
    variants: {},
  }
})
